var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDateIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "21px",
    viewBox: "0 0 19 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u05D1\u05D7\u05D9\u05E8\u05EA \u05EA\u05D0\u05E8\u05D9\u05DA copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u05D4\\u05D5\\u05E1\\u05E4\\u05EA-\\u05DC\\u05E7\\u05D5\\u05D7",
    transform: "translate(-1013.000000, -408.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-32",
    transform: "translate(775.000000, 109.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u05D1\\u05D7\\u05D9\\u05E8\\u05EA-\\u05EA\\u05D0\\u05E8\\u05D9\\u05DA-copy",
    transform: "translate(236.000000, 299.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 23 0 23 23 0 23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2083333,2.875 L17.25,2.875 L17.25,0.958333333 L15.3333333,0.958333333 L15.3333333,2.875 L7.66666667,2.875 L7.66666667,0.958333333 L5.75,0.958333333 L5.75,2.875 L4.79166667,2.875 C3.72791667,2.875 2.88458333,3.7375 2.88458333,4.79166667 L2.875,18.2083333 C2.875,19.2625 3.72791667,20.125 4.79166667,20.125 L18.2083333,20.125 C19.2625,20.125 20.125,19.2625 20.125,18.2083333 L20.125,4.79166667 C20.125,3.7375 19.2625,2.875 18.2083333,2.875 Z M18.2083333,18.2083333 L4.79166667,18.2083333 L4.79166667,7.66666667 L18.2083333,7.66666667 L18.2083333,18.2083333 Z M6.70833333,9.58333333 L11.5,9.58333333 L11.5,14.375 L6.70833333,14.375 L6.70833333,9.58333333 Z",
    id: "Shape",
    fill: "#B1B1B1",
    fillRule: "nonzero"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/date_icon.d0fc64d88a046c35006a9be606413c43.svg";
export { ForwardRef as ReactComponent };